const cssPurge = [];
module.exports = {
  'regular-11': ['11px', '20px'],
  'regular-12': ['12px', '20px'],
  'regular-13': ['13px', '22px'],
  'regular-14': ['14px', '22px'],
  'regular-16': ['16px', '26px'],
  'regular-18': ['18px', '28px'],
  'regular-20': ['20px', '30px'],
  'regular-21': ['21px', '34px'],
  'regular-24': ['24px', '40px'],
  'regular-28': ['28px', '44px'],
  'regular-32': ['32px', '42px'],
  'regular-36': ['36px', '54px'],
  'regular-42': ['42px', '62px'],
  'regular-48': ['48px', '70px'],
  'regular-52': ['52px', '62px'],
  'regular-58': ['58px', '80px'],
  'regular-60': ['60px', '85px'],
  'regular-64': ['64px', '90px'],
  'regular-70': ['70px', '100px'],
  'regular-80': ['80px', '86px'],
  'regular-96': ['96px', '94px'],
  'regular-110': ['110px', '140px'],
};
